export default {"src":"/_next/static/media/navigation-music.636e5731.gif","height":300,"width":400};